
import WebsiteRepositoryInterface, { Website } from '@/services/Website/interfaces';
import { AxiosError } from 'axios';
import { Component, Vue } from 'vue-property-decorator';
import { WPXFormValue } from '@/components/templates/WPXForm';
import CreateDNSZoneForm from '@/services/DNS/forms/CreateDNSZoneForm';
import DNSRepositoryInterface from '@/services/DNS/Interfaces';
import { ServerInterface, ServerRepositoryInterface } from '@/services/Server/Interfaces';

@Component({
  inject: [
    'dnsRepository',
    'serverRepository',
    'websiteRepository',
  ],
})
export default class CreateDns extends Vue {
  public readonly dnsRepository!: DNSRepositoryInterface;
  public readonly serverRepository!: ServerRepositoryInterface;
  public readonly websiteRepository!: WebsiteRepositoryInterface;

  public loading: boolean = true;

  public form: WPXFormValue<CreateDNSZoneForm> = new WPXFormValue(CreateDNSZoneForm);
  public servers: ServerInterface[] = [];

  public websiteSearchLoading: boolean = false;
  public _websiteSearch: string = '';
  public websites: Website[] = [];

  public async created(): Promise<void> {
    this.servers = await this.serverRepository.getAllServers();

    this.loading = false;
  }

  public async addDnsZone(): Promise<void> {
    try {
      await this.dnsRepository.createDNSZone(this.form.data);
    } catch (e) {
      switch ((e as AxiosError)?.response?.status) {
        case 409:
          this.$errorDialog.show("DNS Zone for domain already exists.");
          break;
        default:
          this.$errorDialog.show((e as AxiosError)?.response?.data?.message || (e as Error).message);
          break;
      }
    }
  }

  public showOverwriteWarning(): void {
    if (this.form.data.overwrite) {
      this.$infoDialog.show('Overwriting the DNS Zone will remove the previous DNS Records.')
    }
  }

  public get websiteSearch(): string {
    return this._websiteSearch
  }

  public set websiteSearch(val: string) {
    this._websiteSearch = val;

    this.websiteSearchLoading = true;
    this.websiteRepository.searchWebsites(0, val).then((websitesResponse) => {
      this.websites = websitesResponse.Websites;
      this.websiteSearchLoading = false;
    })
  }

}
